"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
require("./index.less");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _expert = require("@/api/expert/expert");
var _works = require("@/api/works/works");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      photoList: [],
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      isViolationOptions: [{
        value: "1",
        label: "课程资格——申报材料不齐备"
      }, {
        value: "2",
        label: "课程资格——课程无法登录、打开、显示完整内容和教学活动"
      }, {
        value: "3",
        label: "课程资格——负责人非申报学校正式聘任教师"
      }, {
        value: "4",
        label: "课程资格——教师无在线教学服务"
      }, {
        value: "5",
        label: "课程资格——课程应用时间不足二个学期"
      }, {
        value: "6",
        label: "教师资格——课程负责人录制讲授本课程的视频时长少于20%。"
      }, {
        value: "7",
        label: "课程内容——存在思想性或较严重的科学性问题"
      }, {
        value: "8",
        label: "造假——材料、数据造假"
      }, {
        value: "9",
        label: "侵权——发现且确认有侵权现象"
      }, {
        value: "10",
        label: "不适合网络传播——课程内容不适合网络公开传播"
      }],
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "150"
      }, {
        name: "项目组别",
        prop: "groupName",
        isShow: true,
        width: "150"
      }, {
        name: "项目阶段",
        prop: "stageName",
        isShow: true,
        width: "150"
      }, {
        name: "作品/课程名称",
        prop: "worksName",
        isShow: true,
        width: "150"
      }, {
        name: "姓名",
        prop: "userName",
        isShow: true,
        width: "100"
      }, {
        name: "分数",
        prop: "totalScore",
        isShow: true,
        width: "100"
      }],
      options: [{
        name: "审核打分",
        class: "edit",
        option: "auditScore",
        span: 3
      }],
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      viewList: [{}, {}],
      worksId: this.$route.query.worksId,
      worksInfo: [],
      worksMsg: {
        groupId: "",
        matchId: "",
        stageId: ""
      },
      infoList: [{
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }, {
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }, {
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }],
      entryList: [{
        label: "片段节选",
        type: "video",
        src: "",
        url: ""
      }, {
        label: "封面",
        type: "img",
        src: "",
        url: ""
      }, {
        label: "封面",
        type: "img",
        src: "",
        url: ""
      }],
      //评分标准数据
      gradeTable: [{
        id: "",
        scoringName: "",
        scoringContent: "",
        scoringElement: "",
        scoringScore: 0,
        actualScore: 0
      }],
      //评分意见
      gradeForm: {
        id: "",
        worksId: "",
        totalScore: 0,
        isViolation: "",
        content: ""
      },
      isViolation: [],
      //设定阅读时间
      setReadingTime: 0,
      //阅读时间
      readingTime: 0,
      // 已经审核了的时间
      btnEnable: false,
      submitBtnText: 0,
      minWidth: 300,
      listData: [],
      dialogVisible: false,
      queryValue: "",
      timer: ""
    };
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)({
    // 获取快照列表
    getViewList: function getViewList(i) {
      var _this2 = this;
      this.photoList = [];
      (0, _works.getPhotoList)({
        url: i
      }).then(function (res) {
        var v = JSON.parse(res.data).imgs;
        var x = i.replace("file_doc", "file_gen_doc");
        v.forEach(function (item) {
          _this2.photoList.push(x + "/" + item);
        });
      });
    },
    // 根据作品ID获取作品详情
    getWorkInfo: function getWorkInfo() {
      var _this3 = this;
      (0, _works.getWorksById)({
        id: this.$route.query.workId
      }).then(function (res) {
        var data = res.data;
        _this3.worksMsg = data;
        _this3.getScoreRule();
        _this3.getTimes();
        _this3.getRules();
      });
    },
    // 获取当前作品评分项
    getScoreRule: function getScoreRule() {
      var _this4 = this;
      (0, _works.scoreRule)({
        groupId: this.worksMsg.groupId,
        matchId: this.worksMsg.matchId,
        stageId: this.worksMsg.stageId
      }).then(function (res) {
        _this4.gradeTable = res.data;
      });
    },
    // 获取作品浏览时间
    getRules: function getRules() {
      var _this5 = this;
      (0, _works.getRules)({
        stageId: this.worksMsg.stageId
      }).then(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var _this;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                //定时器，检查评审时间是否满足
                _this = _this5;
                _this.timer = setInterval(function () {
                  //设定时间
                  _this5.setReadingTime = res.data.minViewTime * 60;
                  _this5.readingTime++;
                  if (_this5.readingTime < _this5.setReadingTime) {
                    (0, _works.updataReadTime)({
                      id: _this5.$route.query.id
                    }).then(function (res) {
                      console.log("readingTime", _this5.readingTime);
                      console.log("setReadingTime", _this5.setReadingTime);
                    });
                    // this.upDateReadTime();
                    _this5.btnEnable = true;
                    _this5.submitBtnText = "倒计时（" + (_this5.setReadingTime - _this5.readingTime) + "）";
                  } else {
                    clearInterval(_this.timer);
                    _this5.btnEnable = false;
                    _this5.submitBtnText = "提交";
                  }
                }, 1000);
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 已经阅读时间
    getTimes: function getTimes() {
      var _this6 = this;
      (0, _works.getReadTimes)({
        id: this.$route.query.id
      }).then(function (res) {
        _this6.readingTime = res.data;
      });
    },
    // 判断得分
    input: function input() {
      var total = 0;
      this.gradeTable.forEach(function (item) {
        if (parseInt(item.actualScore) > parseInt(item.scoringScore)) {
          item.actualScore = item.scoringScore;
        }
        if (item.actualScore > 0) {
          total += parseInt(item.actualScore);
        }
      });
      this.gradeForm.totalScore = total;
    },
    // 提交
    submit: function submit() {
      var _this7 = this;
      var worksScore = [];
      //判断当前阅读时间是否满足要求
      if (this.readingTime < this.setReadingTime) {
        this.$message({
          message: "最少浏览时间" + this.setReadingTime / 60 + "分钟",
          type: "warning"
        });
        return;
      }
      if (this.gradeTable.length == 0) {
        this.$message({
          message: "暂无评分标准",
          type: "warning"
        });
        return;
      }
      if (this.gradeForm.content == "" || this.gradeForm.content == null) {
        this.$message({
          message: "请输入审核意见",
          type: "warning"
        });
        return;
      }
      // 存在否决指标得分判0
      if (this.isViolation.length > 0) {
        this.gradeTable.forEach(function (item) {
          item.actualScore = "0";
          worksScore.push({
            scoreId: _this7.$route.query.id,
            scoreItemId: item.id,
            score: item.actualScore
          });
        });
        this.gradeForm.totalScore = 0;
      } else {
        //赛事评分
        var verification = 0; //验证分数是否全部填
        var scoreVerification = 0; //验证分数是否超过满分
        this.gradeTable.forEach(function (item) {
          //判断是否有未评分项
          if (item.actualScore == undefined) {
            verification++;
          } else {
            if (+item.actualScore > +item.scoringScore) {
              scoreVerification++;
            }
          }
          worksScore.push({
            scoreId: _this7.$route.query.id,
            scoreItemId: item.id,
            score: item.actualScore
          });
        });
        if (verification > 0) {
          this.$message({
            message: "请输入得分",
            type: "warning"
          });
          return;
        }
        if (scoreVerification > 0) {
          this.$message({
            message: "得分不能超过满分",
            type: "warning"
          });
          return;
        }
      }
      this.gradeForm.isViolation = this.isViolation.join(",");
      (0, _works.updateWorksScore)({
        content: this.gradeForm.content,
        id: this.$route.query.id,
        isViolation: this.gradeForm.isViolation,
        scoreItemParamList: worksScore,
        stageId: this.worksMsg.stageId,
        totalScore: this.gradeForm.totalScore,
        worksId: this.$route.query.workId
      }).then(function (res) {
        if (res.code === 2000) {
          _this7.$router.push("/grade/grade-list");
          _this7.$message.success("操作成功。");
        }
      });
    },
    // 下载
    downLoadFile: function downLoadFile(e) {
      window.open(e);
    },
    // 模糊搜索
    search: function search(e) {
      this.queryValue = e.queryValue;
      this.getMajorList();
    },
    isBack: function isBack() {
      // this.$router.push("/grade/grade-list");
      history.go(-1);
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getMajorList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageNumber = 1;
      this.page.pageSize = e;
      this.getMajorList();
    },
    handleSelectionChange: function handleSelectionChange() {},
    //审核打分
    auditScore: function auditScore(e) {
      this.$router.push({
        path: "/gradeScore/gradeScoreX",
        query: {
          workId: e.worksId,
          id: e.id
        }
      });
      this.dialogVisible = false, location.reload();
    },
    // 点击待审核列表
    isOpen: function isOpen() {
      this.getAuditWorkList();
      this.dialogVisible = true;
    },
    // 获取审核作品列表
    getAuditWorkList: function getAuditWorkList() {
      var _this8 = this;
      (0, _expert.auditByExpertId)({
        groupId: "",
        matchId: "",
        stageId: "",
        name: this.queryValue,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        console.log(data, "list");
        _this8.listData = data.list;
        _this8.totalData = data.total;
      });
    }
  }, "search", function search(e) {
    this.queryValue = e.queryValue;
    this.getMajorList();
  }), "handleClose", function handleClose(done) {
    done();
  }),
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyTable: _zhjyTable.default,
    ZhjyPagination: _zhjyPagination.default
  },
  created: function created() {
    this.getWorkInfo();
  },
  filters: {
    getStatus: function getStatus(status) {
      if (status == 1) {
        return "待审核";
      }
      if (status == 2) {
        return "审核未通过";
      }
      if (status == 3) {
        return "待分配";
      }
      if (status == 4) {
        return "评审中";
      }
      if (status == 5) {
        return "结束";
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, form, next) {
    if (this.timer) {
      clearInterval(this.timer);
    }
    next();
  }
};